import i18next from "i18next";
import { useQuery } from "react-query";
import { z } from "zod";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const OAUTH_PROVIDERS_ENDPOINT = "/api/auth/oauth-providers" as const;

export const getAllOAuthProvidersKey = "getAllOAuthProviders" as const;

export const OAuthProviderSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    providerName: z.string(),
    label: z.string().nullable().optional(),
    clientId: z.string(),
    protocol: z.string(),
    metadataUrl: z.string().nullable().optional(),
    urlAuthorize: z.string(),
    urlAccessToken: z.string(),
    urlResourceOwnerDetails: z.string().nullable().optional(),
    scopes: z.string(),
    externalIdCookieName: z.string().nullable().optional(),
    resourceOwnerHeaders: z.record(z.string(), z.string()).nullable().optional(),
    redirectUrl: z.string().nullable().optional(),
    cookiesToSaveOnPersistence: z.array(z.string()).nullable().optional(),
    resourceOwnerMapping: z
        .record(z.string(), z.union([z.string(), z.array(z.string())]))
        .nullable()
        .optional(),
});

export type OAuthProvider = z.infer<typeof OAuthProviderSchema>;

type Options = {
    enabled?: boolean;
};

export const useGetAllOAuthProviders = (options?: Options) => {
    const query = useQuery({
        queryKey: [getAllOAuthProvidersKey, i18next.resolvedLanguage],
        enabled: options?.enabled ?? true,
        queryFn: async () => {
            return loggedInApiCall.get(OAUTH_PROVIDERS_ENDPOINT, { params: { itemsPerPage: 100 } });
        },
        select: (request) => {
            const data = request.data["hydra:member"];
            return zodParseWithDetailedLog(data, OAuthProviderSchema.array(), {
                operation: "GET",
                endpoint: OAUTH_PROVIDERS_ENDPOINT,
            });
        },
    });

    return {
        oauthProviders: query.data,
        ...query,
    };
};
